module.exports = __webpack_public_path__ + "fonts/Poppins-700-devanagari16.349ed9f.woff2";